import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsMultiNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M21.728 19.088a1.4 1.4 0 00.725.202 1.42 1.42 0 001.22-.72l.86-1.62a.477.477 0 01.43-.26h3.29v-1.65h-3.26a2.156 2.156 0 00-1.104.308 2.14 2.14 0 00-.787.832l-.65 1.22-2.25-4.24a1.41 1.41 0 00-1.655-.687 1.379 1.379 0 00-.31.14 1.4 1.4 0 00-.514.547l-.87 1.63a.469.469 0 01-.43.25h-2.59v1.63h2.59a2.14 2.14 0 001.89-1.14l.65-1.22 2.25 4.23c.118.226.296.416.515.548z"
        fill=""
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.822 26.84c.863-.01 1.721-.122 2.557-.335.869.221 1.767.335 2.673.335A10.86 10.86 0 0031.892 16 10.838 10.838 0 0018.427 5.483a10.705 10.705 0 00-5.042-.045 10.84 10.84 0 10-2.433 21.402c.811 0 1.62-.09 2.41-.27l-.003-.013c.802.187 1.627.283 2.463.283zm-.792-1.827c.073.049.147.097.22.144a9.215 9.215 0 01-3.288-.802 9.193 9.193 0 01-3.946-13.343A9.185 9.185 0 0115.32 6.8a10.833 10.833 0 00-4.898 7.085 10.84 10.84 0 004.609 11.128zm-5.04.125a10.841 10.841 0 01.005-18.28A9.18 9.18 0 005.332 8.73a9.185 9.185 0 00-3.565 7.176 9.194 9.194 0 007.116 9.046 9.1 9.1 0 001.109.186zm5.956-16.742a9.19 9.19 0 015.106-1.556v-.03a9.2 9.2 0 019.2 9.19 9.191 9.191 0 01-18.2 1.84 9.191 9.191 0 013.894-9.444z"
        fill=""
      />
    </svg>
  )
);
SvgSportsMultiNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsMultiNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsMultiNormalMedium;
